export default __webpack_public_path__ + "static/media/error-icon.ec9a5502.png";